module.exports = __webpack_public_path__ + "static/img/謝謝光臨300.f36486aa.png";